import React from "react";
import "./OfferMarquee.css";

const OfferMarquee = () => {
  return (
    <div className="offer-wrapper">
      <div className="offer-marquee">
        <div className="offer-track">
          <span className="offer-badge">🔥 Exclusive Offer</span>
          <span className="offer-text">
            Book a Private Theatre & Get ₹200 FREE Game Coupons!
            
          </span>

          {/* Duplicate for smooth infinite effect */}
          <span className="offer-badge">🔥 Exclusive Offer</span>
          <span className="offer-text">
            Book a Private Theatre & Get ₹200 FREE Game Coupons!
          </span>

          <span className="offer-badge">🔥 Exclusive Offer</span>
          <span className="offer-text">
            Book a Private Theatre & Get ₹200 FREE Game Coupons!
          </span>


          <span className="offer-badge">🔥 Exclusive Offer</span>
          <span className="offer-text">
            Book a Private Theatre & Get ₹200 FREE Game Coupons!
          </span>
        </div>
      </div>
    </div>
  );
};

export default OfferMarquee;